import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ROLE_TYPE } from '../../constants/roles';
import { PAGE_ROUTES } from '../../constants/pageRoutes';
import RenterOwnerComponent from '../dashboard/account/renter-owner-component';

const mapStateToProps = state => ({
  dashboard: state.Dashboard,
  global: state.Global
});

class ListYourProperty extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOwnerSwitchModalOpen: false
    }

    this.onLinkClick = this.onLinkClick.bind(this);
  }

  onLinkClick = () => {
    const { user } = this.props.dashboard;

    if (!user) {
      window.location = '/the-cw-advantage-for-owners/#/';
      return;
    }

    if (user.userType === ROLE_TYPE.owner) {
      window.location = PAGE_ROUTES.CREATE_LISTING_APP_URL;
      return;
    }

    if (user.userType === ROLE_TYPE.renter) {
      this.setState({
        isOwnerSwitchModalOpen: true
      })
    }
  }

  render() {
    const { isResponsive } = this.props;
    const { user } = this.props.dashboard;
    const { errors } = this.props.global;
    return (
      <div>
        <a type='button' className={`list-property-button${isResponsive ? '-responsive' : ''}`} onClick={() => { this.onLinkClick() }}>List your Property</a>
        {this.state.isOwnerSwitchModalOpen &&
          <RenterOwnerComponent user={user}
            onClose={() => {
              this.setState({
                isOwnerSwitchModalOpen: false
              })
            }} errors={errors} />}
      </div>
    )
  }
}

ListYourProperty.propTypes = {
  isResponsive: PropTypes.bool
}

export default connect(mapStateToProps)(ListYourProperty);
